export default __webpack_public_path__ + "static/media/movieClapper.7f90e83a.svg";